// Breakpoints shared with the CSS (documented at the top of design-system.css).
// Media queries are max-width, so "phone" means width <= 480px.
export const BREAKPOINTS = {
  phone: 480,
  tablet: 768,
  laptop: 1024,
};

export const MEDIA = {
  phone: `(max-width: ${BREAKPOINTS.phone}px)`,
  tablet: `(max-width: ${BREAKPOINTS.tablet}px)`,
  laptop: `(max-width: ${BREAKPOINTS.laptop}px)`,
  coarsePointer: '(pointer: coarse)',
  // Any touch screen (an iPad with a Bluetooth scanner or keyboard still matches)
  touch: '(any-pointer: coarse)',
  reducedMotion: '(prefers-reduced-motion: reduce)',
};

// matchMedia that is safe where it doesn't exist (jsdom, very old browsers)
export const matchesMedia = (query) =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false;
